import React from 'react'
import styled from 'styled-components'

const ButtonFullScreen = ({ callback }) => {
    return (
        <Container>
            <button onClick={callback} className="container-fleet-tracking-btn-full-screen">
                <i className="fas fa-expand"></i>
            </button>
        </Container>
    )
}

export default React.memo(ButtonFullScreen)

const Container = styled.div`
    position: relative;
    top: 22px;

    .container-fleet-tracking-btn-full-screen {
        position: relative;
        border: none;
        background: #ffffff;
        border-radius: 3px;
        width: 32px;
        height: 32px;
        font-size: 16px;
        color: #37a3ef;
        margin-bottom: 10px;
    }
`
